'use strict';

var CalcColumnNameService = function CalcColumnNameService() {
  var meta = {
    label: 'New calculated column',
    counter: 0
  };
  function getName() {
    var label = meta.counter >= 1 ? meta.label + ' ' + meta.counter : meta.label;
    meta.counter++;
    return label;
  }
  return {
    getName: getName
  };
};
module.exports = CalcColumnNameService;